export enum CommentPublishEvents {
  LOADING = '@CommentPublish/LOADING',
  ERROR = '@CommentPublish/ERROR'
}
